module.exports = __webpack_public_path__ + "img/activity-logs-unactive.0ca6aa6.svg";